export const HOTJAR_ID = 5240667;
export const GOOGLE_ANALYTICS = "G-J4W91HKYYX";

